import * as THREE from "three"
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import browser from "browser-detect";

import RAF from '../utils/RAF'

import SinglePillardFloor from "./SinglePillardFloor"
import CamParallax from "./CamParallax"


class MainThreeScene {
    constructor() {
        this.bind()
        this.camera
        this.scene
        this.renderer
        this.controls
        this.inited = false
    }

    init() {
        this.inited = true

        //RENDERER SETUP
        this.renderer = new THREE.WebGLRenderer({ antialias: true })
        this.renderer.setSize(window.innerWidth, window.innerHeight)
        this.renderer.debug.checkShaderErrors = true

        this.scene = new THREE.Scene()

        //CAMERA AND ORBIT CONTROLLER
        this.camera = new THREE.PerspectiveCamera(30, window.innerWidth / window.innerHeight, 0.1, 1000)
        this.camera.position.set(0, 50, 0)
        this.controls = new OrbitControls(this.camera, this.renderer.domElement)
        this.controls.enabled = false
        this.controls.maxDistance = 1500
        this.controls.minDistance = 0

        if (!browser().mobile) {
            CamParallax.init(this.camera)
            CamParallax.active = true
        }

        const ambLight = new THREE.AmbientLight(0xFFFFFF, .3)
        const pointLight = new THREE.PointLight({
            intensity: 1
        })
        pointLight.position.set(0, 5, 0)
        this.scene.add(ambLight, pointLight)


        SinglePillardFloor.init(this.scene, this.camera)
    }

    start(container) {
        container.appendChild(this.renderer.domElement)
        RAF.subscribe('threeSceneUpdate', this.update)
        window.addEventListener("resize", this.resizeCanvas)
    }

    stop() {
        RAF.unsubscribe('threeSceneUpdate')
        window.removeEventListener("resize", this.resizeCanvas)
    }

    update() {
        SinglePillardFloor.update()
        if (!browser().mobile) CamParallax.update()
        this.renderer.render(this.scene, this.camera);
    }

    resizeCanvas() {
        this.renderer.setSize(window.innerWidth, window.innerHeight)
        this.camera.aspect = window.innerWidth / window.innerHeight
        this.camera.updateProjectionMatrix()
    }

    bind() {
        this.resizeCanvas = this.resizeCanvas.bind(this)
        this.update = this.update.bind(this)
        this.init = this.init.bind(this)
        this.start = this.start.bind(this)
        this.stop = this.stop.bind(this)
    }
}

const _instance = new MainThreeScene()
export default _instance